"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mailchimp = void 0;
var _reactGa = _interopRequireDefault(require("react-ga"));
var _axios = _interopRequireDefault(require("axios"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
var mailchimp = function mailchimp(mailchimpData, $resultElement, mailchimpUrl, mailchimpListID) {
  _axios["default"].post(mailchimpUrl, {
    mailchimpListID: mailchimpListID,
    data: mailchimpData
  }).then(function (response) {
    if (response.data.result === "success") {
      var message = "For some reason we are unable to add you as a subscriber at this time. Please try again later.";
      if (response.data.msg.indexOf("already subscribed") !== -1) {
        message = "It looks like you are already subscribed.";
        _reactGa["default"].ga("send", "event", "Submission", "Newsletter Sign Up", "Already Subscribed");
      }
      if (response.data.msg.indexOf("fake or invalid") !== -1) {
        message = "Please enter a valid email address.";
        _reactGa["default"].ga("send", "event", 'Submission', "Newsletter Sign Up", "Fake or Invalid");
      }
      $resultElement.innerHTML = message;
    } else {
      _reactGa["default"].ga("send", "event", 'Submission', "Newsletter Sign Up", "Successfully Signed Up");
    }
  })["catch"](function (error) {
    console.log(error);
  });
};
exports.mailchimp = mailchimp;